<template>
  <section class="tracking-section tracking-padding">
    <div class="container" v-if="currentOrder">
      <iframe
        v-if="
          currentOrder.where2_enabled &&
          currentOrder.order_status == enumHelper.orderStatus.DELIVERY &&
          currentOrder.orderWhere2 && (currentOrder.orderWhere2.drop.status != 4 && currentOrder.orderWhere2.pickup.status != 4)
        "
        :src="currentOrder.orderWhere2.drop.tracking_url"
      />
      <order-status v-else :order="currentOrder" />
    </div>
    <div
      v-else
      class="container d-flex justify-content-center align-items-center"
    >
      <img src="/img/dino/dino_tracking.svg" class="dino-tracking p-4" />
    </div>
  </section>
</template>

<script>
import { OrderStatus } from "@/views/components";
import { enumHelper } from "@/utilities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "order-tracking",
  components: {
    OrderStatus,
    //OrderReview,
  },
  data() {
    return {
      enumHelper,
      currentOrder: null,
    };
  },
  computed: {
    ...mapGetters(["getTrackedOrder"]),
  },
  methods: {
    ...mapActions(["saveTrackedOrder", "removeTrackedOrder"]),
    refreshLiveOrder() {
      if (
        this.$route.params.id &&
        (!this.currentOrder ||
          (this.currentOrder &&
            this.currentOrder.order_status < enumHelper.orderStatus.COMPLETED))
      ) {
        let params = {
          order_id: this.$route.params.id,
        };
        this.fetchTrackingOrder(params)
          .then((response) => {
            if (response.data && response.data.id) {
              this.currentOrder = response.data;
              //-- save only if not completed
              if (
                this.currentOrder.order_status <
                enumHelper.orderStatus.COMPLETED
              ) {
                if (
                  !this.getTrackedOrder.find((x) => (x.id = response.data.id))
                ) {
                  this.saveTrackedOrder({ id: this.currentOrder.id });
                }
              } else {
                this.removeTrackedOrder(this.currentOrder.id);
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  created() {
    this.refreshLiveOrder(); // run the refresh is first time
    setInterval(this.refreshLiveOrder, 10000); // 10 seconds
  },
};
</script>